// extracted by mini-css-extract-plugin
module.exports = {"teammember":"TeamMember_teammember__qBkXY","portrait":"TeamMember_portrait__1u0n_","name":"TeamMember_name__VrJl7","role":"TeamMember_role__1C32S","job":"TeamMember_job__8EQdE"};